export enum CallStatus {
    CREATED = 'created',
    ESTABLISHING = 'establishing',
    ESTABLISHED = 'established',
    MEETING_STARTED = 'meetingStarted',
    INVITING = 'inviting',
    INVITED = 'invited',
    TRANSCRIPT_STARTED = 'transcriptStarted',
    DELETING = 'deleting',
    DELETED = 'deleted',
    INITIAL_TRANSCRIPT_STREAMED = 'initialTranscriptStreamed',
    MEETING_ENDED = 'meetingEnded',
    ENDING = 'ending',
    ENDED = 'ended',
    RECORDING_SUCCESS = 'recordingSuccess',
    TRANSCRIPT_SYNCING = 'transcriptSyncing',
    TRANSCRIPT_SYNCED = 'transcriptSynced',
    ERROR = 'error',
}
